export enum CustomizerOption {
  CUSTOMIZE_FOR_ME = "Open AI Writer",
  GET_BRAND_INFO = "Brand Info",
}
